export enum KeyActionsTagEnum {
  confirm = 'confirm',
  return = 'return',
  top = 'top',
  bottom = 'bottom',
  right = 'right',
  left = 'left',
  consolidate = 'consolidate',
  'go_to_open' = 'go_to_open',
  'go_to_in_progress' = 'go_to_in_progress',
  'go_to_waiting' = 'go_to_waiting',
  'go_to_done' = 'go_to_done',
  'go_to_delivered' = 'go_to_delivered',
  'go_to_canceled' = 'go_to_canceled',
}
